import { SortOrder } from '@/models/Global'
import { AdvancedProperty } from '@/models/Property'
import PropertyService from '@/services/PropertyService'
import { useDefaultStore } from '@/store'
import { clone } from '@/utils/tools'
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export const DefaultProductSorting = {
  sortFieldPath: 'sku',
  sortOrder: 'asc',
} as const

export const useSorting = () => {
  const store = useDefaultStore()
  const router = useRouter()
  const route = useRoute()

  const sortBy = async (property: AdvancedProperty, order?: SortOrder) => {
    store.temporaryIgnoreNavigationBlock = true

    const defaultSortOrder = !property.valueType || property.valueType === 'string' ? 'desc' : 'asc'
    const altSortOrder = defaultSortOrder === 'asc' ? 'desc' : 'asc'
    const sortOrder =
      order || (route.query.sortFieldPath === property.sortFieldPath && route.query.sortOrder === altSortOrder ? defaultSortOrder : altSortOrder)

    if (sortOrder === 'asc' && property.sortFieldPath === DefaultProductSorting.sortFieldPath) {
      resetSorting()
      return
    }

    await router.replace({
      query: {
        ...route.query,
        sortFieldPath: property.sortFieldPath,
        sortOrder,
        sortType: property.valueType,
      },
    })

    store.temporaryIgnoreNavigationBlock = false
  }

  const isDefaultProductSorting = computed(
    () =>
      (!route.query.sortFieldPath || route.query.sortFieldPath === DefaultProductSorting.sortFieldPath) &&
      (!route.query.sortOrder || route.query.sortOrder === DefaultProductSorting.sortOrder),
  )

  const resetSorting = async () => {
    store.temporaryIgnoreNavigationBlock = true

    const query = clone(route.query)
    delete query.sortFieldPath
    delete query.sortOrder
    delete query.sortType
    await router.replace({ query })

    store.temporaryIgnoreNavigationBlock = false
  }

  return {
    sortBy,
    resetSorting,
    isDefaultProductSorting,
  }
}
